import { selectNewbuildingInfo } from './selectNewbuildingInfo';
import { IApplicationState } from '../../types/redux';
import { selectActiveNewbuildingPolygon } from '../newbuildingPolygons';

export const selectNewbuildingId = (state: IApplicationState): number | undefined => {
  const newbuildingInfo = selectNewbuildingInfo(state);
  const activePolygon = selectActiveNewbuildingPolygon(state);

  if (activePolygon.newbuildingId) {
    return activePolygon.newbuildingId;
  }

  return newbuildingInfo ? newbuildingInfo.id : undefined;
};
